import { createFileRoute } from "@tanstack/react-router";
import { ResetPassword } from "@/features/signin/ResetPasswordPage";
import { resetSearch } from "@/features/signin/resetSearch";

/** Choose a new password from the reset mail (X21-RESA-09). Public, so it sits outside `_app` like sign-in. */
export const Route = createFileRoute("/reset-password")({
  validateSearch: resetSearch,
  component: () => <ResetPassword search={Route.useSearch()} />,
});
